'use strict';

var NAME           = 'synxis-rates';
var NAMESPACE      = 'hogo.' + NAME;
//var SELECTOR       = '[data-' + NAME + ']';

var $body = $(document.body);


/**
 * Constructor.
 *
 * @param  {DOMElement|string}  element
 * @param  {object}             options
 */
const SynxisRates = function (el, options) {
	this.$element = $(el);
	this.options = $.extend({}, SynxisRates.DEFAULTS, options);

	this.$start_date = this.$element.find('[name="arrive"]');
	this.$end_date   = this.$element.find('[name="depart"]');
	this.$adults     = this.$element.find('[name="adult"]');
	this.$children   = this.$element.find('[name="child"]');
	this.$promo      = this.$element.find('[name="promo"]');

	this.bindEvents();
};

/**
 * Autocomplete version.
 */
SynxisRates.VERSION = '0.1.0';

/**
 * Autocomplete component defaults.
 */
SynxisRates.DEFAULTS = {
	url: '//service-2g7w7t2m-1259788991.ap-hongkong.apigateway.myqcloud.com/release/Prd/Rest/Room',
	macauId: 0,
    cotaiId: 0,
    timeout: 10000,
    beforeRequest: function() {},
    error: function() {},
    success: function() {}
};

/**
 * Bind events to the form element.
 */
SynxisRates.prototype.bindEvents = function ()
{
	this.$element.on('submit', $.proxy(this.handleSubmit, this));
};

/**
 * Return the start date value.
 *
 * @return  {String}
 */
SynxisRates.prototype.getStartDate = function ()
{
	var date = new Date(this.$start_date.val());

	return this.formatDate(date);
};

/**
 * Return the end date value.
 *
 * @return  {String}
 */
SynxisRates.prototype.getEndDate = function ()
{
	// Get the end date minus one day so we are not getting the rates
	// on the actual check-out date.
	var date = new Date(this.$end_date.val());

	// Subtract 1 day
	date.setDate(date.getDate() - 1);

	return this.formatDate(date);
};

/**
 * Return the adult value.
 *
 * @return  {String}
 */
SynxisRates.prototype.getAdults = function ()
{
	return this.$adults.val();
};

/**
 * Return the child value.
 *
 * @return  {String}
 */
SynxisRates.prototype.getChildren = function ()
{
	return this.$children.val();
};

/**
 * Return the promo value.
 *
 * @return  {String}
 */
SynxisRates.prototype.getPromo = function ()
{
	return this.$promo.val();
};

/**
 * When the form is submitted.
 */
SynxisRates.prototype.handleSubmit = function (e)
{
	e.preventDefault();

	this.options.beforeRequest.call(this);

	this.requestRates();
};

/**
 * Request all rates.
 */
SynxisRates.prototype.requestRates = function (data)
{
	$.when(this.getMacauRates(data), this.getCotaiRates(data))
		//.then(null, $.proxy(this.handleError, this))
		.done($.proxy(this.handleComplete, this));
};

/**
 * Send the request to retrieve the macau property rates.
 *
 * @param   {Object}  data
 * @return  {Object}
 */
SynxisRates.prototype.getMacauRates = function (data)
{
	return this.sendRequest($.extend({}, {
		synxisid: this.options.macauId
	}, data), {
		error: $.proxy(function() {
			this.handleError('macau');
		}, this)
	});
};

/**
 * Send the request to retrieve the cotai property rates.
 *
 * @param   {Object}  data
 * @return  {Object}
 */
SynxisRates.prototype.getCotaiRates = function (data)
{
	return this.sendRequest($.extend({}, {
		synxisid: this.options.cotaiId
	}, data), {
		error: $.proxy(function() {
			this.handleError('cotai');
		}, this)
	});
};

/**
 * Consolidate all the data.
 *
 * @param   {Object}  extra  Optional
 * @return  {Object}
 */
SynxisRates.prototype.getData = function (extra)
{
	return $.extend({}, {
		start_date: this.getStartDate(),
		end_date: this.getEndDate(),
		adult: this.getAdults(),
		child: this.getChildren(),
		promo: this.getPromo()
	}, extra);
};

/**
 * Send a request to the API server.
 *
 * @param   {Object}  data
 * @return  {Object}
 */
SynxisRates.prototype.sendRequest = function (data, opts)
{
	opts = opts || {};

	return $.ajax($.extend({}, {
		url: this.options.url,
		data: this.getData(data),
		method: 'GET',
		dataType: 'json',
		timeout: this.options.timeout
	}, opts));
};

/**
 * Filter through the rates and return an array of all items
 * that are a non-zero value.
 *
 * @param   {Array}  rates
 * @return  {Array}
 */
SynxisRates.prototype.filterRates = function (rates)
{
    var filtered = [];
    for (var i = 0; i < rates.length; i++) {
        if (parseInt(rates[i].rate, 10) !== 0) {
            filtered.push(rates[i]);
        }
    }
    return filtered;
}

/**
 * Return the lowest rate from the ones passed.
 *
 * @param   {Array}  rates
 * @return  {Object}
 */
SynxisRates.prototype.lowestRate = function (rates)
{

    var filtered = this.filterRates(rates);

    var lowest = null;
    for (var i = 0; i < filtered.length; i++) {
        if ( ! lowest || parseInt(lowest.rate, 10) > parseInt(filtered[i].rate, 10)) {
            lowest = filtered[i];
        }
    }

    return lowest;
}

/**
 * Handles any errors returned from the API (i.e. Timeout).
 *
 */
SynxisRates.prototype.handleError = function ()
{
	this.options.error.apply(this, arguments);
};

/**
 * Process the response from the completed AJAX requests.
 *
 * @param  {Array}  a1
 * @param  {Array}  a2
 */
SynxisRates.prototype.handleComplete = function (a1, a2)
{
	this.processMacau(a1[0]);
	this.processCotai(a2[0]);
};

/**
 * Formats the date into what is accepted by the API.
 * i.e. 2017-01-31
 *
 * @param   {Date|String}  date
 * @return  {String}
 */
SynxisRates.prototype.formatDate = function (date)
{
	if (typeof date === 'object') {
		return date.getFullYear() +
			'-' + ('0' + (date.getMonth() + 1)).slice(-2) +
			'-' + ('0' + date.getDate()).slice(-2);
	}

	return date;
};

/**
 * Processes the Macau property response.
 *
 * @param  {Object}  rates
 */
SynxisRates.prototype.processMacau = function (rates)
{
	var lowest = this.lowestRate(rates);

	this.options.success.call(this, lowest, 'macau', this.macauCounter);
};

/**
 * Processes the Cotai property response.
 *
 * @param  {Object}  response
 */
SynxisRates.prototype.processCotai = function (rates)
{
	var lowest = this.lowestRate(rates);

	this.options.success.call(this, lowest, 'cotai', this.cotaiCounter);
};


// AUTOCOMPLETE PLUGIN DEFINITION
// ==============================

function Plugin (option)
{
    var args = [];
    for (var i = 1; i < arguments.length; i++) {
        args.push(arguments[i]);
    }

    return this.each(function () {
        var $this = $(this);
        var options = $.extend({}, SynxisRates.DEFAULTS, $this.data(), typeof option == 'object' && option)

        var data  = $this.data(NAMESPACE);

        if ( ! data) $this.data(NAMESPACE, (data = new SynxisRates(this, options)));
        if (typeof option === 'string') data[option].apply(data, args);
    });
}

$.fn.synxisRates             = Plugin;
$.fn.synxisRates.Constructor = SynxisRates;


// APPLY TO STANDARD DATE SELECT ELEMENTS
// ======================================

//$(SELECTOR).synxisRates();


// BIND EVENTS
// ===========

//$(document);



// EXPORT MODULE
// =============

export default SynxisRates;